/**
 * @generated SignedSource<<a0416df1a52ffb45b000db30536c357f>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "UpdateScheduleTemplatePayload",
            "kind": "LinkedField",
            "name": "updateScheduleTemplate",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfScheduleTemplate",
                    "kind": "LinkedField",
                    "name": "templateEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ScheduleTemplate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ScheduleTemplateHeaderUpdateTemplateMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ScheduleTemplateHeaderUpdateTemplateMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "92162ac0ae82e51d83637a08de01f892",
            "id": null,
            "metadata": {},
            "name": "ScheduleTemplateHeaderUpdateTemplateMutation",
            "operationKind": "mutation",
            "text": "mutation ScheduleTemplateHeaderUpdateTemplateMutation(\n  $model: UpdateTemplateRequestInput!\n) {\n  updateScheduleTemplate(model: $model) {\n    templateEdge {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "99cd576b1da9c20b5cc4448aa42febbc";
export default node;
